const EventEmitter = require('wolfy87-eventemitter')
const ee = new EventEmitter()

export const emitEvent = (eventName, date) => ee.emitEvent(eventName, date)

export const addListener = (eventName, listener) => ee.addListener(eventName, listener)

export const removeListener = (eventName, listener) => ee.removeListener(eventName, listener)